var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("app-modal", {
        attrs: { "max-width": "1200", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.title))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showLoading,
                        expression: "showLoading",
                      },
                    ],
                    staticClass: "text-xs-center",
                  },
                  [
                    _c("v-progress-circular", {
                      attrs: { size: 70, color: "primary", indeterminate: "" },
                    }),
                    _vm._v(" "),
                    _c("h2", [_vm._v("Loading...")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-form",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showLoading,
                        expression: "!showLoading",
                      },
                    ],
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c("v-subheader", { staticClass: "headline" }, [
                      _vm._v("General"),
                    ]),
                    _vm._v(" "),
                    _c("ImporterGeneral", {
                      attrs: {
                        Title: _vm.title,
                        data: _vm.generalData,
                        ImporterType: _vm.ImporterType,
                      },
                      on: { setGeneralData: _vm.setGeneralData },
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c("v-subheader", { staticClass: "headline" }, [
                      _vm._v("Shared"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pr-3": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "OptimumStationId",
                                rules: _vm.numRuleNoZero,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c("v-icon", _vm._g({}, on), [
                                                    _vm._v("info_outline"),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _vm._v(
                                            "\n                  System uses the optimum station Id to download the logger information.\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.OptimumStationId,
                                callback: function ($$v) {
                                  _vm.OptimumStationId = $$v
                                },
                                expression: "OptimumStationId",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pl-3": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Data Logger Name",
                                rules: _vm.nullRule,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c("v-icon", _vm._g({}, on), [
                                                    _vm._v("info_outline"),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _vm._v(
                                            "\n                  System uses the data logger name to filter the inputs for the stations.\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.DataLoggerName,
                                callback: function ($$v) {
                                  _vm.DataLoggerName = $$v
                                },
                                expression: "DataLoggerName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "AccessToken", rules: _vm.nullRule },
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c("v-icon", _vm._g({}, on), [
                                                _vm._v("info_outline"),
                                              ]),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _vm._v(
                                        "\n                Authentication access token for optimum API calls.\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.AccessToken,
                            callback: function ($$v) {
                              _vm.AccessToken = $$v
                            },
                            expression: "AccessToken",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c("v-subheader", { staticClass: "headline" }, [
                      _vm._v("Mappings"),
                    ]),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "HotFolderName", rules: _vm.nullRule },
                      model: {
                        value: _vm.NGConfig.HotFolderName,
                        callback: function ($$v) {
                          _vm.$set(_vm.NGConfig, "HotFolderName", $$v)
                        },
                        expression: "NGConfig.HotFolderName",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      disabled: !_vm.canSave,
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.showModal,
          callback: function ($$v) {
            _vm.showModal = $$v
          },
          expression: "showModal",
        },
      }),
      _vm._v(" "),
      _c(
        "app-confirmation-modal",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.saveFailed,
            callback: function ($$v) {
              _vm.saveFailed = $$v
            },
            expression: "saveFailed",
          },
        },
        [
          _c("template", { slot: "title" }, [_vm._v("\n      Failed\n    ")]),
          _vm._v(" "),
          _c("template", { slot: "text" }, [
            _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "actions" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: {
                    click: function ($event) {
                      _vm.saveFailed = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }